import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import NotaCreditoFactura from "./NotaCreditoFactura";
import Http from "../../../Http";
import Dialogo from '../../../components/dialog/Dialog';
import Snackbar from "../../../components/alert/Snackbar";
import ACCESS from "../../../ACCESS.js";

class NotaCreditoFacturas extends TableComponent {

  // state = {
  //   // editFactura: false
  // }

  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `nota-credito/factura/${this.props.notaCreditoId}/filter`,
        deleteUrl: "nota-credito/factura/delete",
        deleteField: "id_factura",
        // modUrl: "/Ventas/Deposito",
      },
      TableOp.Table(
        false,
        [
          { label: "Factura", id: "tipo_cons" },
          { label: "Subtotal", id: "subtotal" },
          { label: "I.V.A.", id: "iva" },
          { label: "Retención", id: "retencion" },
          { label: "Total", id: "total" },
          { label: "Fecha", id: "createdAt" },
        ],
        [
          { id: "edits", icon: "edit", cb: this.onEdit, access: [ACCESS.COBRANZA_NOTA_CREDITO.CREAR_NOTA_DE_CREDITO] },
          { id: 'deletes', icon: 'delete', cb: this.onDelete, access: [ACCESS.COBRANZA_NOTA_CREDITO.CREAR_NOTA_DE_CREDITO] },
        ]
      )
    );
    this.table();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reloadCount !== this.props.reloadCount) {
      this.table();
    }
  }

  onFacturaClose = () => {
    this.setState({ editFactura: false });
  }

  onFacturaSave = () => {
    console.log('factura save')
    this.setState({ editFactura: false });
    this.table();
    this.props.onEdited();
  }

  onEdit = (id, row) => {
    this.setState({ editFactura: true, editFacturaData: row })
  }

  onDelete = (id, row) => {
    this.deleteRow = row;
    this.setState({
      dialog: {
        title: `¿Borrar la factura ${row.id_factura}?`,
        body: '',
        options: ['Sí', 'No'],
        show: true,
      }
    })
  }

  dialogClose = async (op) => {
    this.setState({ dialog: { ...this.state.dialog, show: false } })
    if (op === 2) {
      let Res = await Http.post(`nota-credito/factura/delete`, this.deleteRow);
      if (!Res.error) {
        this.table();
        this.props.onEdited();
      }
      else {
        Snackbar(`Error: ${Res.errMsg}`)
      }
    }
  }

  render() {
    const { notaCredito } = this.props;
    const { editFactura = false, editFacturaData } = this.state;
    return (
      <div>
        <this.TableRender />

        <Dialog
          onClose={this.onFacturaClose}
          open={editFactura}
          fullWidth={true}
          maxWidth={"xl"}
        >
          {/* <DialogTitle onClose={this.onFacturaClose}>Factura</DialogTitle> */}
          <DialogContent dividers>
            <NotaCreditoFactura notaFactura={editFacturaData || {}} notaCredito={notaCredito} onSave={this.onFacturaSave} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onFacturaClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>

        <Dialogo dialog={this.state.dialog} onClose={this.dialogClose} />
      </div>
    );
  }
}

export default withRouter(NotaCreditoFacturas);
